module.exports = __webpack_public_path__ + "static/media/photo122.673c92d5.jpg";